import flagsmith from 'flagsmith'
import type { IFlagsmith } from 'flagsmith/types'
import type { FeatureFlag, TraitOptions } from './flags.types'

export const typedFlagsmith = flagsmith as IFlagsmith<FeatureFlag, TraitOptions>
